// Pure helpers of the Property Tax tab (PropertyTax.tsx), kept out of the .tsx so the server test of
// package proptax (server/src/scripts/testProptax.ts) runs the very same code.

export type FeeRow = { taxAmount: number; serviceFee: number | null };

/** A row's service fee is unknown when it has no fee of its own and the firm's fee per property is not
 *  set: the list sends null, or the row stores 0 while the firm's fee is not set. */
export const feeUnknownOf = (r: FeeRow, feeUnset: boolean): boolean => r.serviceFee == null || (!r.serviceFee && feeUnset);

/** Toolbar and footer totals. The tax total is always a number. The fee total and the grand total are
 *  null (shown as "—", like a row's own total) as soon as ONE row's fee is unknown — never a sum that
 *  quietly counts that row as 0 and so looks complete while it is too low. */
export const propTaxTotals = (rows: FeeRow[], feeUnset: boolean): { tax: number; fee: number | null; total: number | null; unknownRows: number } => {
  const tax = rows.reduce((s, r) => s + (r.taxAmount || 0), 0);
  const unknownRows = rows.filter(r => feeUnknownOf(r, feeUnset)).length;
  if (unknownRows) return { tax, fee: null, total: null, unknownRows };
  const fee = rows.reduce((s, r) => s + (r.serviceFee || 0), 0);
  return { tax, fee, total: tax + fee, unknownRows: 0 };
};
